import React, { useEffect, useRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicePickerStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { getLanguage } from 'utils/language/language';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISliderProps {
	children: React.ReactElement[];
	wrapperWidth: number;
	currentPage: number;
	numberOfPages: number;
	numberOfTabs: number;
	numberOfTabsOnSlide: number;
	arrowsHidden: boolean;
}

const Slider = ({
	children,
	wrapperWidth,
	currentPage,
	numberOfPages,
	numberOfTabs,
	numberOfTabsOnSlide,
	arrowsHidden,
}: ISliderProps) => {
	const classes = useStyles();
	const language = getLanguage();
	const sliderRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (sliderRef.current) {
			let scroll = 0;
			if (currentPage > 0 && currentPage === numberOfPages - 1 && numberOfTabs % numberOfTabsOnSlide !== 0) {
				scroll =
					(currentPage - 1) * wrapperWidth +
					((numberOfTabs % numberOfTabsOnSlide) / numberOfTabsOnSlide) * wrapperWidth;
			} else {
				scroll = currentPage * wrapperWidth;
			}
			if (language === 'ar') {
				sliderRef.current.setAttribute('style', `right: -${scroll}px`);
			} else {
				sliderRef.current.setAttribute('style', `left: -${scroll}px`);
			}
		}
	}, [wrapperWidth, currentPage, numberOfPages, numberOfTabs, numberOfTabsOnSlide, language]);

	return (
		<div className={classNames(classes.slider, { [classes.sliderWithHiddenArrows]: arrowsHidden })} ref={sliderRef}>
			{children}
		</div>
	);
};

export default Slider;
